/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IRR } from './IRR';
import {
    IRRFromJSON,
    IRRFromJSONTyped,
    IRRToJSON,
} from './IRR';

/**
 * 
 * @export
 * @interface IRRInvestment
 */
export interface IRRInvestment {
    /**
     * 
     * @type {number}
     * @memberof IRRInvestment
     */
    investmentNumber: number;
    /**
     * 
     * @type {string}
     * @memberof IRRInvestment
     */
    investmentName: string;
    /**
     * 
     * @type {Array<IRR>}
     * @memberof IRRInvestment
     */
    iRRTable: Array<IRR>;
}

/**
 * Check if a given object implements the IRRInvestment interface.
 */
export function instanceOfIRRInvestment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentNumber" in value;
    isInstance = isInstance && "investmentName" in value;
    isInstance = isInstance && "iRRTable" in value;

    return isInstance;
}

export function IRRInvestmentFromJSON(json: any): IRRInvestment {
    return IRRInvestmentFromJSONTyped(json, false);
}

export function IRRInvestmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRRInvestment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentNumber': json['InvestmentNumber'],
        'investmentName': json['InvestmentName'],
        'iRRTable': ((json['IRRTable'] as Array<any>).map(IRRFromJSON)),
    };
}

export function IRRInvestmentToJSON(value?: IRRInvestment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentNumber': value.investmentNumber,
        'InvestmentName': value.investmentName,
        'IRRTable': ((value.iRRTable as Array<any>).map(IRRToJSON)),
    };
}

